import script from "./SupportExamples.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportExamples.vue?vue&type=script&lang=ts&setup=true"

import "./SupportExamples.vue?vue&type=style&index=0&id=517290c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517290c6"]])

export default __exports__